module.exports = __webpack_public_path__ + "static/account.d2ffd6ab.png";